import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output, OnInit,
} from '@angular/core';

@Component({
  selector: 'ut-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StarRatingComponent implements OnInit {
  @Input() rating: number = 0;
  @Input() max: number = 5;
  @Input() readonly: boolean = false;
  @Output() ratingChange = new EventEmitter<number>();

  stars: number[] = [];

  ngOnInit(): void {
    this.stars = Array.from({ length: this.max }, (_, i) => i + 1);
  }

  onStarClick(star: number): void {
    if (!this.readonly) {
      this.rating = star;
      this.ratingChange.emit(this.rating);
    }
  }

  isStarFilled(star: number): boolean {
    return star <= this.rating;
  }
}
